var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "booking-header",
      attrs: { "data-component": "booking-header" },
    },
    [
      _c("div", { staticClass: "booking-header-wrapper container" }, [
        _c("div", { staticClass: "booking-header-left" }, [
          !_vm.isApp
            ? _c("a", {
                staticClass: "icon-fan-logo",
                attrs: { "aria-label": "logo", href: _vm.homeUrl },
                on: {
                  click: _vm.cartRemoveEventTag,
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar",
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.cartRemoveEventTag($event)
                  },
                },
              })
            : _c("a", {
                staticClass: "icon-close-white",
                attrs: { href: "?status=closed" },
              }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "booking-header-left-cta booking-header-item" },
            [
              _c("language-switcher", {
                attrs: { languages: _vm.languages },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var activate = ref.activate
                      var displayName = ref.displayName
                      return _c(
                        "div",
                        { staticClass: "language-switcher-wrapper" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "language",
                              on: {
                                click: activate,
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "space",
                                      32,
                                      $event.key,
                                      [" ", "Spacebar"]
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return activate($event)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "icon-globe" }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "language-drop-down" },
                                [_vm._v(_vm._s(displayName))]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "icon-chevron-down" }),
                            ]
                          ),
                        ]
                      )
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("currency-switcher", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var activate = ref.activate
                      return _c(
                        "button",
                        {
                          staticClass: "currency-drop-down booking-header-item",
                          class: _vm.isTravelAgent ? "no-border" : "",
                          on: {
                            click: activate,
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "space",
                                  32,
                                  $event.key,
                                  [" ", "Spacebar"]
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return activate($event)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.currentCurrency) +
                              "\n            "
                          ),
                          _c("span", { staticClass: "icon-chevron-down" }),
                        ]
                      )
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        !_vm.isTravelAgent
          ? _c(
              "div",
              { staticClass: "booking-header-right" },
              [
                !_vm.haveProfileData
                  ? _c("auth-activator", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var activate = ref.activate
                              return [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn-wrapper booking-header-item",
                                    on: {
                                      click: function ($event) {
                                        return activate("login", $event.target)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "booking-login" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.tc("auth.logIn")) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "signin",
                                      attrs: {
                                        "aria-label": _vm.tc("auth.logIn"),
                                        "tab-index": "0",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3988050177
                      ),
                    })
                  : _c(
                      "div",
                      {
                        staticClass: "btn-wrapper booking-header-item",
                        class: {
                          "booking-header-item--login": _vm.haveProfileData,
                        },
                      },
                      [
                        _c("div", { staticClass: "booking-login" }, [
                          _c("a", { attrs: { href: _vm.userProfileUrl } }, [
                            _c("span", { staticClass: "desktop-up" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.tc("auth.welcomeText", {
                                      name:
                                        _vm.user.title +
                                        " " +
                                        _vm.user.lastName,
                                    })
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "signin",
                              attrs: {
                                "aria-label": _vm.tc("auth.logIn"),
                                "tab-index": "0",
                              },
                            }),
                          ]),
                        ]),
                      ]
                    ),
                _vm._v(" "),
                _vm.haveProfileData
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "btn-wrapper booking-header-item booking-header-item--logout",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "btn-wrapper booking-header-item" },
                          [
                            _c("div", { staticClass: "booking-login" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "logout-button",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.logout($event)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        viewBox: "0 0 24 25",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M16 17.5L21 12.5L16 7.5",
                                          "stroke-width": "1.2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d: "M21 12.5H9",
                                          "stroke-width": "1.2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d: "M9 21.5H5C4.46957 21.5 3.96086 21.2893 3.58579 20.9142C3.21071 20.5391 3 20.0304 3 19.5V5.5C3 4.96957 3.21071 4.46086 3.58579 4.08579C3.96086 3.71071 4.46957 3.5 5 3.5H9",
                                          "stroke-width": "1.2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "desktop-up" }, [
                                    _vm._v(
                                      _vm._s(_vm.additionalData.logoutText)
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }